import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const page = usePage()

const errors = computed(() => {
    return page.props.errors
})

const hasErrors = computed(() => {
    return Object.keys(errors.value).length > 0
})

export const useError = () => {
    return {
        hasErrors,
        errors
    }
}
